import Typography from '@mui/material/Typography'
import { Box } from '@mui/material'
import { closeModal } from 'actions/app'
import { useDispatch } from 'react-redux'
import { Button } from '@mui/material'
import * as c from 'common/c'
import colors from 'common/colors'

export default function ScreenSizeWarning({ onScroll }) {
  const width = window.screen.width * 0.6
  const height = window.screen.height * 0.35
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onCloseClicked = useCallback(() => {
    localStorage.setItem(c.WARNING_CLEARED_KEY, true)
    dispatch(closeModal())
  })

  return (
    <Box
      onScroll={onScroll}
      className="screenSizeWarning"
      sx={{
        px: 3,
        py: 4,
        height: height + 'px',
        margin: 'auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: 'auto',
        width: width + 'px',
      }}
    >
      <Typography align="left" component="p" variant="h5">
        <b>{t('screen_resolution_warning')}</b>
      </Typography>
      <Typography align="left" component="p">
        {t('screen_size_warning_one')} <b>{t('screen_size_warning_two')}</b>.{' '}
        {t('screen_size_warning_three')}.
      </Typography>
      <Button
        align="left"
        style={{ backgroundColor: colors.brandSecondary, display: 'block' }}
        onClick={onCloseClicked}
      >
        {t('acknowledge_and_continue')}
      </Button>
    </Box>
  )
}
